define.alias("shared/utils/formatters/ig-story-from-dynamo", "media/utils/formatters/ig-story-from-dynamo");